import {Base} from "@/api/Base"

export class MpfSettingDelete extends Base {
    path = "mpfSetting/delete"
}